exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".feature-list{width:100%;padding:0;margin-bottom:20px}.feature-list-content{margin-right:-50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22686111","scoped":false,"hasInlineConfig":true}!./src/components/feature-list/feature-list.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-22686111","scoped":false,"hasInlineConfig":true}!./src/components/feature-list/feature-list.css
// module chunks = index